// extracted by mini-css-extract-plugin
export default {"choice":"DomainRow-choice_zy8Ru"};